import ApiService from "../api.service";
const HelperService = {
  GetStateList() {
    return ApiService.get(`/Helper/GetStateList`);
  },
  GetStatusList() {
    return ApiService.get(`/Helper/GetStatusList`);
  },
  GetModuleList(lang) {
    return ApiService.get(`/Helper/GetModuleList?lang=${lang}`);
  },
  GetRoleList() {
    return ApiService.get(`/Helper/GetRoleList`);
  },
  SyncErpTables() {
    return ApiService.get(`/Helper/SyncErpTables`);
  },
  GetEmployeeListForComponent(
    OnDate,
    DepartmentID,
    HREmpAppointOrderTypeID,
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    isTeacher
  ) {
    return ApiService.get(
      `/Helper/GetEmployeeListForComponent?OnDate=${OnDate}&DepartmentID=${DepartmentID}&HREmpAppointOrderTypeID=${HREmpAppointOrderTypeID}&Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&isTeacher=${isTeacher}`
    );
  },
  GetAllFinYear() {
    return ApiService.get(`/Helper/GetAllFinYear`);
  },
  GetAllPurchaseBase() {
    return ApiService.get(`/Helper/GetAllPurchaseBase`);
  },
  GetAllTradeType() {
    return ApiService.get(`/Helper/GetAllTradeType`);
  },
};
export default HelperService;
